import ApplicationSerializer from 'lumen/serializers/application';

export default class ConfigSerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey() {
    return 'parity/config';
  }
}
